export default {
  isSearchOpen: false,
  showATCSticky: false,
  isMiniCartOpen: false,
  activeVariant: {},
  headerScrolled: false,
  cart: window.HU.cart,
  activeProduct: window.HU.product,
  cartMeta: [],
  activeDrawer: null,
  bundleProducts: [],
  searchResults: {},
  searchAttributes: {},
  freeGiftVariantId: 0,
  freeGiftType: '',
  freeGiftGoal: 0,
  freeGiftTotalGoal: 0,
  modalActivate: null,
  modalToggleEl: null,
  selectedOptions: {}
}
